import ApiService from "@/services/Api"

type GetCardByClientIdResponse = {
	card: BoardStageCard
}

export type BoardCardStatus = "won" | "lost"

export type MoveCardBetweenStagesInput = {
	cardId: number
	targetStageId: number
	nextCardId?: number
	responsibleUserId?: number
	contactValueInCents?: number
	lossReasonId?: number
	lossReasonCustomText?: string
}

export type ClientInCard = {
	clientId: number
	clientInCardId: number
	cardId: number
	name?: string
	nickname: string
	phone: string
	email?: string
	pictureUrl?: string
}

export type BoardStageCard = {
	id: number
	responsibleUserId: number
	stageId: number
	boardId: number
	name: string
	cardOrder: number
	clients: Array<ClientInCard>
}

export type CreateBoardStageCardResponse = {
	card: BoardStageCard
}

export type CreateBoardStageCard = {
	board: {
		id: number
	},
	stage: {
		id: number
	}
	client: {
		id: number
	}
	createdFrom: "CHAT-BOT" | "INBOX" | "BULK-CONTACTS-TO-FUNNEL" | "FUNNEL"
}

type RemoveBoardStageCardInput = {
	board: {
		id: number
	}
	stage: {
		id: number
	}
	card: {
		id: number
	}
}

export type UpdateContactValueInput = {
	clientId: number
	contactValueInCents: number
}

export type UpdateContactValueResponse = {
	id: number
	contactValueInCents: number
}

class BoardStageCardService {
	async createBoardStageCard (input: CreateBoardStageCard): Promise<BoardStageCard> {
		const response = await ApiService.post<CreateBoardStageCardResponse>(`/boards/${input.board.id}/stages/${input.stage.id}/cards`, {
			client: {
				clientId: input.client.id
			},
			createdFrom: input.createdFrom
		})

		return response.data.card
	}

	async getCardByClientId (clientId: number): Promise<BoardStageCard> {
		const response = await ApiService.get<GetCardByClientIdResponse>(`boards/cards/clients/${clientId}`)

		return response.data.card
	}

	async moveCardBetweenStages (input: MoveCardBetweenStagesInput): Promise<void> {
		await ApiService.put("/boards/stages/cards/move", {
			...input
		})
	}

	async removeCardFromBoardStage (input: RemoveBoardStageCardInput): Promise<void> {
		await ApiService.delete(`/boards/${input.board.id}/stages/${input.stage.id}/cards/${input.card.id}`)
	}

	async updateContactValue (input: UpdateContactValueInput): Promise<UpdateContactValueResponse> {
		const response = await ApiService.put<UpdateContactValueResponse>(`/client-catalog/clients/${input.clientId}/contact-value`, {
			contactValueInCents: input.contactValueInCents
		})

		return response.data
	}
}

export default new BoardStageCardService()
